<template>
    <JobsTable v-if="$can('view', 'orders')" :title="t('menu.all_orders')" icon="tabler-stack-2" :headers="headers"
        type="all" :show-actions-menu="true" />
    <VAlert v-else type="warning" variant="tonal">
        {{ $t('admin_notifications.no_permission') }}
    </VAlert>
</template>

<script setup>
definePage({
    meta: {
        action: 'view',
        subject: 'orders',
    },
})

import JobsTable from '@/components/polyhen/jobs/JobsTable.vue'
import { useHead } from '@unhead/vue'

const { t } = useI18n()

// Set page title
useHead({
    title: t('admin_notifications.all_orders'),
    meta: [
        { name: 'description', content: t('admin_notifications.all_orders_description') }
    ]
})

// Headers for all jobs table
const headers = computed(() => [
    {
        title: 'ID',
        key: 'id',
        sortable: false,
        width: '80px',
        align: 'right'
    },
    {
        title: 'PH',
        key: 'ph',
        sortable: false,
        width: '100px',
        align: 'right'
    },
    {
        title: t('admin_notifications.order'),
        key: 'order',
        sortable: false,
        width: '250px',
    },
    {
        title: t('admin_notifications.customer'),
        key: 'customer',
        sortable: false,
        width: '150px',
    },
    {
        title: t('admin_notifications.printer'),
        key: 'printer',
        sortable: false,
        width: '150px',
    },
    {
        title: t('admin_notifications.assigned'),
        key: 'assigned',
        sortable: false,
        width: '120px',
    },
    // {
    //     title: t('admin_notifications.opening_date'),
    //     key: 'created_at',
    //     sortable: false,
    //     width: '140px',

    // },
    {
        title: t('admin_notifications.status'),
        key: 'status',
        sortable: false,
        width: '140px',
    },
    {
        title: t('admin_notifications.actions'),
        key: 'actions',
        sortable: false,
        width: '100px',
    },
])
</script>